// @flow

export const URL_REGEX = /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
const maxLinkLength = 50;

export default class TextExtractor {
    static words(text: string): string[] {
        return text.split(/\s|([.,:;]+[\s$])/);
    }

    static urls(text: string): string[] {
        const words = this.words(text);
        return words
            .map(word => {
                // $FlowFixMe
                return URL_REGEX.test(word) ? word : null;
            })
            .filter(x => !!x);
    }

    static firstUrl(text: string): string | null {
        const urls = this.urls(text);
        return urls.length ? urls[0] : null;
    }

    static domain(url: string): string {
        let domain;

        if (url.indexOf("://") > -1) {
            domain = url.split("/")[2];
        } else {
            domain = url.split("/")[0];
        }

        if (domain.indexOf("www.") > -1) domain = domain.split("www.")[1];

        return domain.split(":")[0];
    }

    static stripVideo(url: string, encode: boolean = false): string {
        let stripped = url
            .split("//")
            .pop() // Strip http(s?)://
            .split("www.")
            .pop(); // Strip www.
        if (stripped.indexOf("?") !== -1) {
            let split = stripped.split("?");
            let params = split[1];
            for (let i = 0; i < params.length; i++) {
                if (params[i].indexOf("v=") === 0) {
                    stripped = split[0] + "?" + params[i];
                    break;
                }
            }
        }

        if (encode) {
            return stripped.replace("?", "%3F");
        }

        return stripped;
    }

    /**
     * Strip HTML/XML tags.
     *
     * Match:
     * <a>hello world</a>
     * <a href="#">hello world</a>
     * <a href="aa" nocontent>hello world</a>
     *
     * DOES NOT match:
     * 4 < 5 && 8 > 10
     * 4 < 5
     * 8 > 10
     */
    static stripTags(html: string): string {
        return html.replace(/<\/?\w+(.*?)>/g, "");
    }

    static linkify(text: string, prepend: string = ""): string {
        text = this.stripTags(text);
        this.urls(text).forEach(url => {
            let shortenedUrl = url;
            if (shortenedUrl.length > maxLinkLength)
                shortenedUrl = shortenedUrl.substring(0, maxLinkLength) + "...";

            text = text.replace(
                url,
                '<a href="' +
                    prepend +
                    url +
                    '" target="_blank">' +
                    shortenedUrl +
                    "</a>"
            );
        });

        return text;
    }

    static breakLines(text: string): string {
        return text.replace(/(\r\n|\r|\n)/g, "<br />");
    }
}



// WEBPACK FOOTER //
// ./src/app/util/TextExtractor.js